import config from '../_config/config.const';

export function isEmbeddedInIframe(): boolean {
    try {
        return window.self !== window.top;
    } catch {
        return true;
    }
}

// Get list of allowed target origins
const TARGET_ORIGINS: string[] = Array.isArray((config as any).ORIGINS) && (config as any).ORIGINS.length
    ? (config as any).ORIGINS
    : (config as any).ORIGIN
        ? [(config as any).ORIGIN]
        : [];

// Helper to post a message to all allowed parent origins
const postToAllowedParents = (message: unknown) => {
    if (!isEmbeddedInIframe()) return;

    if (!TARGET_ORIGINS.length) {
        window.parent.postMessage(message, '*');
        return;
    }

    TARGET_ORIGINS.forEach(origin => {
        try {
            window.parent.postMessage(message, origin);
        } catch (err) {
            console.warn(`[postMessage] failed for origin "${origin}":`, err);
        }
    });
};

let lastSentHeight = 0;
const STUB_HEIGHT = 280;

function getEmbedContentHeight(): number {
    const formContainer = document.getElementById("formContainer");
    if (formContainer && formContainer.scrollHeight > 100) return formContainer.scrollHeight + 50;

    const appScreen = document.getElementById("app-screen");
    if (appScreen) return Math.max(appScreen.scrollHeight, appScreen.offsetHeight);

    return document.body.scrollHeight;
}

function postHeight(height: number) {
    const rounded = Math.ceil(height);
    if (rounded < 1) return;

    const formContainer = document.getElementById("formContainer");
    const hasRealForm = !!formContainer && formContainer.scrollHeight > 100;
    if (!hasRealForm && rounded < STUB_HEIGHT) return;

    if (lastSentHeight > 0 && rounded < lastSentHeight) return;
    if (Math.abs(rounded - lastSentHeight) < 8) return;
    lastSentHeight = rounded;
    postToAllowedParents({
        type: "RESIZE",
        height: rounded,
    });
}

export const sendHeightToParent = () => {
    postHeight(getEmbedContentHeight());
};

export const sendBodyHeightToParent = () => {
    postHeight(getEmbedContentHeight());
};



export const sendContainerHeightToParent = () => {
    const container = document.getElementById('formContainer');
    if (!container) return;
    postHeight(container.scrollHeight + 100);
};

export const sendContainerHeightToParent2 = () => {
    const container = document.getElementById("formContainer");
    const containerHeight = container ? container.scrollHeight : 0;
    postHeight(Math.max(containerHeight, 0) + 50);
};


export function sendScrollMessageToParent() {
    postToAllowedParents({
        type: "SCROLL_TOP",
        offset: 120,
    });
}

export function holdCurrentIframeHeight() {
    if (!isEmbeddedInIframe()) return;
    const px = Math.max(window.innerHeight || 0, lastSentHeight);
    if (px < 200) return;
    document.documentElement.style.setProperty("--lq-hold-height", `${px}px`);
    document.documentElement.classList.add("lq-hold-height");
}

export function releaseHeldIframeHeight() {
    document.documentElement.classList.remove("lq-hold-height");
    document.documentElement.style.removeProperty("--lq-hold-height");
}

export function retryHeight(sendHeightFn: () => void, maxAttempts = 10, delay = 300) {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    let attempts = 0;

    const trySendingHeight = () => {
        if (attempts >= maxAttempts) return;
        attempts++;

        requestAnimationFrame(() => {
            setTimeout(() => {
                sendHeightFn();
                if (attempts < maxAttempts) {
                    // console.log(`[Retry] Sending body height (attempt ${attempts + 1})`);
                    trySendingHeight();
                }
            }, delay);
        });
    };

    trySendingHeight();
}
